import {
  shortCodeAcquire,
  textService,
} from "../../OtherValueAdded/MobileTextMessage";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";

const MobileTextMessagesServiceOverview = ({ data }) => {
  const {
    ov_mtm_service_code,
    ov_mtm_service_short_code,
    ov_mtm_service_code_other,
  } = data["4_4"];

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <div i2c-grid="12@md" className="review-summary-sub-heading">
          <div className="fw-700 font-bold">
            Mobile Text Messaging Service (mRay)
          </div>
        </div>
        <ReviewAttribute
          label="Would you like to acquire a dedicated short code via i2c?"
          value={textService.find((ser) => ser.value === ov_mtm_service_code)?.label ?? "-"}
        />
        {ov_mtm_service_code === "other" && (
          <ReviewAttribute
            label="Acquire short code for text messaging"
            value={ov_mtm_service_code_other || "-"}
          />
        )}
        <ReviewAttribute
          label="What type of short code would you like to acquire?"
          value={shortCodeAcquire.find((ser) => ser.value === ov_mtm_service_short_code)?.label ?? "-"}
        />
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default MobileTextMessagesServiceOverview;
